import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcManagementWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5 7.5C5 6.94771 5.44772 6.5 6 6.5H22C22.5523 6.5 23 6.94772 23 7.5V24.5C23 25.0523 22.5523 25.5 22 25.5H6C5.44772 25.5 5 25.0523 5 24.5V7.5Z",
			fill: "#C4D7FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 6.5H21V22.5C21 23.0523 20.5523 23.5 20 23.5H8C7.44772 23.5 7 23.0523 7 22.5V6.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19 12H9V11H19V12ZM15 14.5H9V13.5H15V14.5ZM9 17H19V16H9V17Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13 2.5H15C15.2761 2.5 15.5 2.72386 15.5 3V4.5H17.3806C17.5013 4.5 17.6155 4.5545 17.6915 4.64832L19.6043 7.01124C19.7631 7.20739 19.6235 7.5 19.3711 7.5H8.62881C8.37645 7.5 8.23686 7.20739 8.39564 7.01124L10.3085 4.64832C10.3844 4.5545 10.4987 4.5 10.6194 4.5H12.5V3C12.5 2.72386 12.7238 2.5 13 2.5Z",
			fill: "#C4D7FD"
		})
	]
});
export default SvgIcManagementWhite;
